// URLs que llevan un secreto en el PATH (no en la query). Hoy: el link personal
// de agenda del socio, /partners/agendar/<token> (spec calendarios GHL §4.1).
// El token es una llave: quien lo tiene agenda demos a nombre del socio y le
// gasta el tope de citas. Lo usan el scrubber de Sentry (los tres runtimes), la
// telemetría de Vercel (cliente) y la exclusión de los píxeles de marketing.
// Sin `server-only`: es puro y corre también en el navegador.

/** Prefijos cuyo SIGUIENTE segmento es secreto. Terminan en "/". */
export const SECRET_PATH_PREFIXES = ["/partners/agendar/"] as const

const PATH_PLACEHOLDER = "[token]"
export const TOKEN_PLACEHOLDER = "[REDACTED_TOKEN]"

// `/partners/agendar/<segmento>` dentro de una URL completa, una ruta o un texto
// (p. ej. la cabecera Referer). El segmento termina en /, ?, #, espacio o comilla.
const SECRET_SEGMENT_RE = /(\/partners\/agendar\/)[^/?#\s"'&]+/g

// El token suelto (formato de lib/referrals/bookingToken: v1.<id b64url>.<firma
// b64url>): viaja sin su ruta en el cuerpo de la server action y en la cabecera
// next-router-state-tree. Sin \b al inicio: en la cabecera URL-codificada el
// token va pegado a un "%22" y entre "2" y "v" no hay frontera de palabra.
const BARE_TOKEN_RE = /v1\.[A-Za-z0-9_-]{40,}\.[A-Za-z0-9_-]{40,}/g

/** Reemplaza el segmento secreto por `[token]`. Lo demás de la URL queda igual. */
export function redactSecretPaths(url: string): string {
  return url.replace(SECRET_SEGMENT_RE, `$1${PATH_PLACEHOLDER}`)
}

/** `redactSecretPaths` más el token suelto, para textos que no son una URL. */
export function redactSecretText(text: string): string {
  return redactSecretPaths(text).replace(BARE_TOKEN_RE, TOKEN_PLACEHOLDER)
}

/** `beforeSend` de Vercel Analytics y Speed Insights: la misma forma, con la URL limpia. */
export function redactTelemetryEvent<E extends { url: string }>(event: E): E {
  return { ...event, url: redactSecretPaths(event.url) }
}
